import PropTypes from "prop-types";
import React from "react";
import { Icon } from "semantic-ui-react";

export const TotalInfoCard = ({
  message = "You have totally created",
  count = 0,
  unit = "assets",
  style = {},
}) => {
  const rootStyle = {
    display: "flex",
    alignItems: "center",
    gap: 12,
    borderRadius: 10,
    border: "1.5px solid #2b5b7b",
    padding: "0 14px",
    background: "#ffffff",
    ...style,
  };

  const textStyle = {
    color: "#222",
    fontSize: 14,
    lineHeight: 1.25,
  };

  const strongStyle = {
    fontWeight: 700,
    display: "inline-block",
    marginLeft: 6,
  };

  return (
    <div aria-label={`${message} ${count} ${unit}`} style={rootStyle}>
      <Icon name="file outline" size="large" />

      <div style={textStyle}>
        <span>{message}</span>
        <span style={strongStyle}>
          {count} {unit}.
        </span>
      </div>
    </div>
  );
};

TotalInfoCard.propTypes = {
  message: PropTypes.string,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  unit: PropTypes.string,
  style: PropTypes.object,
};
